/* tslint:disable:no-console */
var MockButton = /** @class */ (function () {
    function MockButton() {
        this._elements = [];
    }
    MockButton.prototype.show = function (params, element, showCb) {
        console.log('show', params, element);
        var elements = Array.prototype.slice.call(element.children);
        for (var index in elements) {
            if (elements.hasOwnProperty(index)) {
                document.body.appendChild(elements[index]);
                this._elements.push(elements[index]);
            }
        }
        if (showCb) {
            showCb();
        }
    };
    MockButton.prototype.resize = function (params) {
        console.log('resize', params);
    };
    MockButton.prototype.hide = function (params) {
        console.log('hide', params);
    };
    MockButton.prototype.destroy = function (params) {
        console.log('destroy');
    };
    return MockButton;
}());
export { MockButton };
